window.axios = require('axios');
window.fuse = require('fuse.js');
window.Vue = require('vue');

import hljs from 'highlight.js/lib/highlight';

// // Syntax highlighting
hljs.registerLanguage('bash', require('highlight.js/lib/languages/bash'));
hljs.registerLanguage('css', require('highlight.js/lib/languages/css'));
hljs.registerLanguage('html', require('highlight.js/lib/languages/xml'));
hljs.registerLanguage('javascript',
  require('highlight.js/lib/languages/javascript'));
hljs.registerLanguage('json', require('highlight.js/lib/languages/json'));
hljs.registerLanguage('markdown',
  require('highlight.js/lib/languages/markdown'));
hljs.registerLanguage('php', require('highlight.js/lib/languages/php'));
hljs.registerLanguage('scss', require('highlight.js/lib/languages/scss'));
hljs.registerLanguage('yaml', require('highlight.js/lib/languages/yaml'));
//
document.querySelectorAll('pre code').forEach((block) => {
  hljs.highlightBlock(block);
});

Vue.config.productionTip = false;

import Search from './components/Search.vue';
import BrandButton from './components/BrandButton';

const ListIcon = () => import('./components/ListIcon');
const Highlight = () => import('./components/Highlight');
const Quotation = () => import('./components/Quote');
const NewsletterSignup = () => import('./components/NewsletterSignup');

Vue.prototype.$window = window;

new Vue({
  components: {
    Search,
    ListIcon,
    BrandButton,
    Highlight,
    Quotation,
    NewsletterSignup,
  },
}).$mount('#app');
